import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Row } from 'react-bootstrap';
import Blockquote from '../../../../components/Blockquote';
import CircledIcon from '../../../../components/CircledIcon';
import GenericCards from '../../../../components/GenericCards';
import IconButton from '../../../../components/IconButton';
import Radio from '../../../../components/Radio/Radio';
import RadioGroup from '../../../../components/Radio/RadioGroup';
import Support from '../../../../components/Support';
import SupportMobile from '../../../../components/Support/SupportMobile';

export type Step3Props = {
  data: any;
  collectStepData: (data: any) => void;
};

export type PlanOption = {
  id: string;
  sectionId: number;
  name: string;
  benefitAmount: string;
  beneficiary: string;
};

export type PlanDataSource = {
  title: string;
  sections: {
    id: number;
    subTitle: string;
    options: {
      id: number;
      sectionId: number;
      name: string;
      benefitAmount: string;
      beneficiary: string;
    }[];
  }[];
};

export const optionInitialState = {
  id: '',
  sectionId: 0,
  name: '',
  benefitAmount: '',
  beneficiary: '',
};

const contributoryPlanData = {
  title: 'Qualified Plan',
  sections: [
    {
      id: 1,
      subTitle: 'Spouse’s normal form of benefit',
      options: [
        {
          id: 1,
          sectionId: 1,
          name: '50% Joint & Survivor',
          benefitAmount: '$455.62',
          beneficiary: '$227.81',
        },
      ],
    },
    {
      id: 2,
      subTitle: 'Lump Sum option',
      options: [
        {
          id: 2,
          sectionId: 2,
          name: 'Lump-Sum Payment',
          benefitAmount: '$59,493.60',
          beneficiary: 'N/A',
        },
      ],
    },
    {
      id: 3,
      subTitle: 'Lifetime option',
      options: [
        {
          id: 3,
          sectionId: 3,
          name: 'Single Life',
          benefitAmount: '$495.78',
          beneficiary: 'N/A',
        },
        {
          id: 4,
          sectionId: 3,
          name: '5 Year Certain & Continuous',
          benefitAmount: '$481.29',
          beneficiary: '$481.29',
        },
        {
          id: 5,
          sectionId: 3,
          name: '10 Year Certain & Continuous',
          benefitAmount: '$472.92',
          beneficiary: '$472.92',
        },
        {
          id: 6,
          sectionId: 3,
          name: '15 Year Certain & Continuous',
          benefitAmount: '$456.40',
          beneficiary: '$456.40',
        },
      ],
    },
    {
      id: 4,
      subTitle: 'Temporary annuity options',
      options: [
        {
          id: 7,
          sectionId: 4,
          name: '5 Year Certain',
          benefitAmount: '$530.01',
          beneficiary: '$530.01',
        },
        {
          id: 8,
          sectionId: 4,
          name: '10 Year Certain',
          benefitAmount: '$520.20',
          beneficiary: '$520.20',
        },
        {
          id: 9,
          sectionId: 4,
          name: '15 Year Certain',
          benefitAmount: '$505.67',
          beneficiary: '$505.67',
        },
      ],
    },
  ],
};

const nonContributoryPlanData = {
  title: 'Non-Qualified Plan',
  sections: [
    {
      id: 5,
      subTitle: 'Spouse’s normal form of benefit',
      options: [
        {
          id: 10,
          sectionId: 5,
          name: '50% Joint & Survivor',
          benefitAmount: '$455.62',
          beneficiary: '$227.81',
        },
      ],
    },
    {
      id: 6,
      subTitle: 'Lump Sum option',
      options: [
        {
          id: 11,
          sectionId: 6,
          name: 'Lump-Sum Payment',
          benefitAmount: '$59,493.60',
          beneficiary: 'N/A',
        },
      ],
    },
    {
      id: 7,
      subTitle: 'Lifetime option',
      options: [
        {
          id: 12,
          sectionId: 7,
          name: 'Single Life',
          benefitAmount: '$495.78',
          beneficiary: 'N/A',
        },
        {
          id: 13,
          sectionId: 7,
          name: '5 Year Certain & Continuous',
          benefitAmount: '$481.29',
          beneficiary: '$481.29',
        },
        {
          id: 14,
          sectionId: 7,
          name: '10 Year Certain & Continuous',
          benefitAmount: '$472.92',
          beneficiary: '$472.92',
        },
        {
          id: 15,
          sectionId: 7,
          name: '15 Year Certain & Continuous',
          benefitAmount: '$456.40',
          beneficiary: '$456.40',
        },
      ],
    },
    {
      id: 8,
      subTitle: 'Temporary annuity options',
      options: [
        {
          id: 16,
          sectionId: 8,
          name: '5 Year Certain',
          benefitAmount: '$530.01',
          beneficiary: '$530.01',
        },
        {
          id: 17,
          sectionId: 8,
          name: '10 Year Certain',
          benefitAmount: '$520.20',
          beneficiary: '$520.20',
        },
        {
          id: 18,
          sectionId: 8,
          name: '15 Year Certain',
          benefitAmount: '$505.67',
          beneficiary: '$505.67',
        },
      ],
    },
  ],
};

const cashBalanceData = {
  title: 'Cash Balance Plan',
  sections: [
    {
      id: 9,
      subTitle: 'Spouse’s normal form of benefit',
      options: [
        {
          id: 19,
          sectionId: 9,
          name: '50% Joint & Survivor',
          benefitAmount: '$535.89',
          beneficiary: '$267.49',
        },
      ],
    },
    {
      id: 10,
      subTitle: 'Lump Sum option',
      options: [
        {
          id: 20,
          sectionId: 10,
          name: 'Lump-Sum Payment',
          benefitAmount: '$9,4244.46',
          beneficiary: 'N/A',
        },
      ],
    },
    {
      id: 11,
      subTitle: 'Lifetime option',
      options: [
        {
          id: 21,
          sectionId: 11,
          name: 'Single Life',
          benefitAmount: '$495.78',
          beneficiary: 'N/A',
        },
        {
          id: 22,
          sectionId: 11,
          name: '5 Year Certain & Continuous',
          benefitAmount: '$481.29',
          beneficiary: '$481.29',
        },
        {
          id: 23,
          sectionId: 11,
          name: '10 Year Certain & Continuous',
          benefitAmount: '$472.92',
          beneficiary: '$472.92',
        },
        {
          id: 24,
          sectionId: 11,
          name: '15 Year Certain & Continuous',
          benefitAmount: '$456.40',
          beneficiary: '$456.40',
        },
        {
          id: 25,
          sectionId: 11,
          name: '75% Joint & Survior',
          benefitAmount: '$456.40',
          beneficiary: '$456.40',
        },
        {
          id: 26,
          sectionId: 11,
          name: '100% Joint & Survivor',
          benefitAmount: '$456.40',
          beneficiary: '$456.40',
        },
      ],
    },
  ],
};

const getSectionDataById = (
  sectionId: number | string,
  dataSource: PlanDataSource
) => {
  return dataSource.sections.find((section) => section.id === sectionId);
};

const renderMySelections = (
  selectedOption: PlanOption,
  dataSource: PlanDataSource
) => {
  return (
    <>
      <Row className="pt-4">
        <Col>
          <span className="text-caption">
            {' '}
            {getSectionDataById(selectedOption.sectionId, dataSource)?.subTitle}
          </span>
        </Col>
      </Row>
      <Row className="text-caption border-bottom py-4">
        <Col className="text-ligther-grey fw-light col-lg-6">
          {selectedOption.name}
        </Col>
        <Col> {selectedOption.benefitAmount} </Col>
        <Col> {selectedOption.beneficiary} </Col>
      </Row>
    </>
  );
};

const renderOptionGroups = (
  dataVariable: PlanOption,
  handlerFunction: (e: string | number, clear?: boolean) => void,
  dataSource: PlanDataSource
) => {
  return (
    <>
      {dataSource.sections.map((section, index) => (
        <div key={index}>
          <Row
            key={section.id}
            className="pt-11 pb-4 px-0 border-bottom-dark-gray"
          >
            <Col>{section.subTitle}</Col>
          </Row>
          {section.options.map((option, i) => (
            <RadioGroup
              key={i}
              name={section.id.toString()}
              value={dataVariable.id}
              onChange={handlerFunction}
            >
              <Row
                key={i}
                className={`text-fs-6 py-4 lh-xs selectable-row text-primary ${
                  option.id.toString() === dataVariable.id.toString()
                    ? 'text-primary selected'
                    : ''
                }`}
              >
                <Col className="col-7 text-primary">
                  <Radio
                    name={option.sectionId.toString()}
                    value={option.id}
                    label={option.name}
                    className={'indigo-radio-label'}
                    checked={
                      option.id.toString() === dataVariable.id.toString()
                    }
                    id={option.id.toString()}
                  />
                </Col>
                <Col className="text-end">{option.benefitAmount}</Col>
                <Col className="text-end">{option.beneficiary}</Col>
                <Col className="col-1 pt-0 d-none d-lg-block">
                  {option.id.toString() === dataVariable.id.toString() && (
                    <IconButton
                      variant="clear-selection"
                      icon={light('xmark')}
                      onClick={() => {
                        handlerFunction(option.id, true);
                      }}
                    />
                  )}
                </Col>
              </Row>
            </RadioGroup>
          ))}
        </div>
      ))}
    </>
  );
};

const PlanSelectionStep = ({ data, collectStepData }: Step3Props) => {
  // CONTRIBUTORY
  const handleContributoryPlanChange = (
    e: number | string,
    clear?: boolean
  ) => {
    // If clear button is clicked - the clear argument is 'true' we 'clear' the value of the selected option
    if (clear === true) {
      collectStepData({
        ...data,
        contributorySelectedPlan: optionInitialState,
      });
    } else {
      // Find parent section by option ID
      let parentSection = contributoryPlanData.sections.find((section) => {
        return section.options.some((option) => {
          return option.id === e;
        });
      });
      // Get all option object data from parent section and set it in step data
      if (parentSection) {
        const planOptionSelected = parentSection.options.find(
          (element) => element.id === e
        );
        collectStepData({
          ...data,
          contributorySelectedPlan: planOptionSelected,
        });
      }
    }
  };
  const clearContributory = () => {
    collectStepData({
      ...data,
      contributorySelectedPlan: optionInitialState,
    });
  };

  // NON CONTRIBUTORY
  const handleNonContributoryPlanChange = (
    e: string | number,
    clear?: boolean
  ) => {
    if (clear === true) {
      collectStepData({
        ...data,
        nonContributorySelectedPlan: optionInitialState,
      });
    } else {
      let parentSection = nonContributoryPlanData.sections.find((section) => {
        return section.options.some((option) => {
          return option.id === e;
        });
      });

      if (parentSection) {
        const planOptionSelected = parentSection.options.find(
          (element) => element.id === e
        );
        collectStepData({
          ...data,
          nonContributorySelectedPlan: planOptionSelected,
        });
      }
    }
  };

  const clearNonContributory = () => {
    collectStepData({
      ...data,
      nonContributorySelectedPlan: optionInitialState,
    });
  };

  // CASH BALANCE
  const handleCasheBalanceChange = (e: string | number, clear?: boolean) => {
    if (clear === true) {
      collectStepData({
        ...data,
        cashBalanceSelectedPlan: optionInitialState,
      });
    } else {
      let parentSection = cashBalanceData.sections.find((section) => {
        return section.options.some((option) => {
          return option.id === e;
        });
      });

      if (parentSection) {
        const planOptionSelected = parentSection.options.find(
          (element) => element.id === e
        );
        collectStepData({
          ...data,
          cashBalanceSelectedPlan: planOptionSelected,
        });
      }
    }
  };
  const clearCashBalance = () => {
    collectStepData({
      ...data,
      cashBalanceSelectedPlan: optionInitialState,
    });
  };

  return (
    <section>
      <Row>
        <Col className="col-12 col-lg-9">
          <Row>
            <div className="d-flex flex-row justify-content-between align-items-center">
              <h5 className={'mt-12 text-sm-20-lg-24'}>Select Plan</h5>
              <div className={'mt-12 text-sm-20-lg-24 d-lg-none'}>
                <SupportMobile>
                  <div className="p-0 mt-4">
                    <span className="fw-bold text-caption">
                      Retirement Case Administrator
                    </span>
                    <div className="mt-4">
                      <CircledIcon
                        icon={light('user-headset')}
                        label="Jessica Wright"
                      />
                    </div>
                    <div className="mt-4">
                      <CircledIcon
                        icon={light('phone')}
                        label="1-800-888-8888 x 1234"
                      />
                    </div>
                  </div>
                </SupportMobile>
              </div>
            </div>
          </Row>
          <Row className="pt-7 px-0">
            <span className="text-fs-6 lh-xs fw-light">
              Choose the right payment plan for you, there are options ranging
              from Qualified, Non-Qualified and Cash Balance plans.
            </span>
          </Row>
          <Row>
            <Col className="d-flex flex-column pt-7">
              <Blockquote lineVariant="default">
                <span className="text-ligther-grey pl-10">
                  Note: You selected a beneficiary other than your spouse. Your
                  spouse will be required to waive his/her rights to a payment
                  options with an automatic survivor benefit and will not
                  receive any benefit upon your death. For each plan we have
                  shown the normal form of benefit so that you and your spouse
                  can make an informed decision.
                </span>
              </Blockquote>
            </Col>
          </Row>
        </Col>
        <div className="d-none d-lg-flex justify-content-lg-end col-lg-3">
          <section className="mt-12">
            <Support>
              <div className="p-0 mt-4">
                <span className="fw-bold text-caption">
                  Retirement Case Administrator
                </span>
                <div className="mt-4">
                  <CircledIcon
                    icon={light('user-headset')}
                    label="Jessica Wright"
                  />
                </div>
                <div className="mt-4">
                  <CircledIcon
                    icon={light('phone')}
                    label="1-800-888-8888 x 1234"
                  />
                </div>
              </div>
            </Support>
          </section>
        </div>
      </Row>

      <Row className="pt-12 ">
        <Col className="col-lg-8 col-12">
          <GenericCards variant="white">
            <span className="pt-10">
              <h6>Qualified Plan</h6>
            </span>
            <Row className="text-fs-6 text-ligther-grey pt-10 px-0">
              <Col className="col-7 fw-light">Options</Col>
              <Col className="fw-light">Benefit Amount</Col>
              <Col className="fw-light">Beneficiary</Col>
            </Row>
            {renderOptionGroups(
              data.contributorySelectedPlan,
              handleContributoryPlanChange,
              contributoryPlanData
            )}
          </GenericCards>
          <GenericCards variant="white" className="mt-10">
            <span className="pt-10">
              <h6>Non-Qualified Plan</h6>
            </span>
            {renderOptionGroups(
              data.nonContributorySelectedPlan,
              handleNonContributoryPlanChange,
              nonContributoryPlanData
            )}
          </GenericCards>
          <GenericCards variant="white" className="mt-10">
            <span className="pt-10">
              <h6>Cash Balance Plan</h6>
            </span>
            {renderOptionGroups(
              data.cashBalanceSelectedPlan,
              handleCasheBalanceChange,
              cashBalanceData
            )}
          </GenericCards>
        </Col>
        <Col className="col-lg-4">
          <GenericCards
            variant="white"
            className="mt-lg-0 mt-10 "
            style={{ position: 'sticky', top: '100px' }}
          >
            <span className="pt-10">
              <h6>My Selections</h6>
            </span>
            <section className="pt-8">
              <>
                <Row className="indigo-row lh-xs text-fs-6 p-3">
                  <Col className="col-10">Qualified Plan</Col>
                  <Col className="col-2 pe-0 text-end">
                    <IconButton
                      variant="clear-selection-white"
                      icon={light('xmark')}
                      onClick={clearContributory}
                    />
                  </Col>
                </Row>
                {data.contributorySelectedPlan.id !== '' &&
                  renderMySelections(
                    data.contributorySelectedPlan,
                    contributoryPlanData
                  )}
              </>
            </section>
            <section className="pt-8">
              <Row className="indigo-row lh-xs text-fs-6 p-3">
                <Col className="col-10">Non-Qualified Plan</Col>
                <Col className="col-2 pe-0 text-end">
                  <IconButton
                    variant="clear-selection-white"
                    icon={light('xmark')}
                    onClick={clearNonContributory}
                  />
                </Col>
              </Row>
              {data.nonContributorySelectedPlan.id !== '' &&
                renderMySelections(
                  data.nonContributorySelectedPlan,
                  nonContributoryPlanData
                )}
            </section>
            <section className="pt-8">
              <Row className="indigo-row lh-xs text-fs-6 p-3">
                <Col className="col-10">Cash Balance Plan</Col>
                <Col className="col-2 pe-0 text-end">
                  <IconButton
                    variant="clear-selection-white"
                    icon={light('xmark')}
                    onClick={clearCashBalance}
                  />
                </Col>
              </Row>
              {data.cashBalanceSelectedPlan.id !== '' &&
                renderMySelections(
                  data.cashBalanceSelectedPlan,
                  cashBalanceData
                )}
            </section>
          </GenericCards>
        </Col>
      </Row>
    </section>
  );
};

export default PlanSelectionStep;
